import { render } from "./SpurConfirm.vue?vue&type=template&id=31c1df68&ts=true"
import script from "./SpurConfirm.vue?vue&type=script&lang=ts"
export * from "./SpurConfirm.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src599522923/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__